// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__ru+Pt","spin":"spinner_spin__kfjyq"};